export default "__VITE_ASSET__25a68fe5__"